import { createFileRoute } from "@tanstack/react-router";

import LogoutPage from "@/components/Login/LogoutPage";

export const Route = createFileRoute("/logout")({
  component: LogoutPage,
});
